import axios from 'axios';
import { queueVisit } from '../common/experiment-visits';

export default {
    data() {
        return {
            cookieName: 'experiment',
            allowedEvents: [
                'search_page_view', // Homepage + Craft location pages
                'vehicle_select_page_view', // Vehicles list
                'options_page_view', // Options page
                'driver_details_page_view', // Driver details page
                'payment_details_page_view', // Payment details page
                'combined_payment_details_page_view', // Combined driver and payment page
                'thank_you_page_view', // Thank you page
            ],
            unallocatedExperimentSlug: 'unallocated',
        };
    },

    methods: {
        resolveQuoteId() {
            return this.$route?.params?.id || this.$route?.params?.quote_id || this.quote?.id || null;
        },

        getCookie() {
            const regex = new RegExp('(^|;)\\s*' + this.cookieName + '\\s*=\\s*([^;]+)');
            var match = document.cookie.match(regex);

            if (match) {
                try {
                    return JSON.parse(decodeURIComponent(match.pop()));
                } catch (error) {
                    return null;
                }
            }

            return null;
        },

        getCookieByName(name) {
            const cookies = document.cookie.split(';');

            for (let cookie of cookies) {
                cookie = cookie.trim();
                if (cookie.startsWith(name + '=')) {
                    return decodeURIComponent(cookie.substring(name.length + 1));
                }
            }

            return null;
        },

        setCookie(name, value, minutes = null) {
            let expires = '';

            const date = new Date();

            if (minutes) {
                date.setTime(date.getTime() + minutes * 60 * 1000);
            } else {
                // Expires in 1 year by default
                date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
            }

            expires = '; expires=' + date.toUTCString();

            // Save to main domain
            let domain = window.location.hostname.split('.').splice(-2).join('.');

            // If the domain start with ".com" it may be a multi-part domain like ".com.mt", so we need to get an additional part
            if (domain.startsWith('com.') || domain.startsWith('co.')) {
                domain = window.location.hostname.split('.').splice(-3).join('.');
            }

            document.cookie = name + '=' + encodeURIComponent(value) + expires + '; domain=.' + domain + '; path=/';
        },

        getSession(event_name) {
            if (!this.allowedEvents.includes(event_name)) {
                return null;
            }

            return window.sessionStorage.getItem(event_name);
        },

        getApiAxiosCall() {
            let coreEndpoint = window.greenmotion ? window.greenmotion.coreEndpoint : '';

            return axios.create({
                baseURL: API_BASE_URL || coreEndpoint,
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
            });
        },

        async checkExperiment(experiment_slug) {
            const ab_cookie = this.getCookie();
            const quote_id = this.resolveQuoteId();
            const visitorId = this.getCookieByName('experiment_visitor_id');

            const params = quote_id
                ? {
                      visitor_id: visitorId,
                      quote_id,
                  }
                : {
                      visitor_id: visitorId,
                  };

            if (ab_cookie && !quote_id) {
                return (
                    {
                        slug: ab_cookie.experiment_slug,
                        complete: ab_cookie.complete_experiments.includes(experiment_slug),
                    } ?? null
                );
            }

            // If no cookie, check API for experiment
            // --------------------------------------------------
            const experiment_info = await this.getApiAxiosCall()
                .get(`ab/${experiment_slug}/check-experiment`, {
                    params,
                })
                .then((response) => response.data);

            // Only save the cookie if the user is in a experiment
            if (experiment_info?.experiment_slug) {
                // Set Cookie (expire in 10 minutes)
                const mins = 10;
                var date = new Date();
                date.setTime(date.getTime() + mins * 60 * 1000);
                var expires = '; expires=' + date.toUTCString();

                // Cookie Domain
                var domain = new URL(window.location.href).hostname;
                const parts = domain.split('.');
                domain = parts.length > 2 ? parts.slice(1).join('.') : domain;
                domain = '; domain=.' + domain;

                document.cookie = this.cookieName + '=' + JSON.stringify(experiment_info) + domain + expires + '; path=/';
            }

            return (
                {
                    slug: experiment_info.experiment_slug,
                    complete: experiment_info.complete_experiments.includes(experiment_slug),
                } ?? null
            );
        },

        addVisit(event_name, event_data = {}) {
            return this.addVisitAndEventForQuoteJourney(event_name, {
                page_title: document.title,
                page_location: window.location.href,
                page_path: window.location.pathname,
                ...event_data,
            });
        },

        addVisitAndEventForQuoteJourney(event_name, event_data = {}) {
            const visitorId = this.getCookieByName('experiment_visitor_id');
            const quoteId = event_data?.quote_id || this.resolveQuoteId();
            const baseUrl = this.getApiAxiosCall().defaults.baseURL || '/';

            queueVisit(baseUrl, event_name, {
                visitor_id: visitorId,
                from_cookie: !!visitorId,
                ...event_data,
                ...(quoteId ? { quote_id: quoteId } : {}),
            });
        },

        async notifyGoogleAnalytics(event_name, event_data) {
            let debug_mode_enabled = window.greenmotion && typeof window.greenmotion.googleDebugModeEnabled !== 'undefined' ? window.greenmotion.googleDebugModeEnabled : false;
            const http = this.getApiAxiosCall();

            let google_event_data = event_data;

            // Debug mode should be handle by a variable, to avoid activating the debug mode in production
            if (debug_mode_enabled) {
                google_event_data = {
                    debug_mode: true,
                    ...google_event_data,
                };
            }

            gtag('event', event_name, google_event_data);
        },
    },
};
